/* tslint:disable:max-line-length */
import * as svgs from "../../assets/iconExports";
export const svgIcons = new Map([
    ["add-user", { svg: svgs.udir_add_user }],
    ["application", { svg: svgs.application, size: 12 }],
    ["arrow-next", { svg: svgs.arrow_thick_right_fill_large_sm }],
    ["arrow-previous", { svg: svgs.arrow_thick_left_fill_large_sm }],
    ["arrow-up", { svg: svgs.arrow_thick_top_fill_large_sm, colorizeBy: "fillAndStroke" }],
    ["arrow-down", { svg: svgs.arrow_thick_bottom_fill_large_sm, colorizeBy: "fillAndStroke" }],
    ["building", { svg: svgs.building_sm }],
    ["check-clean", { svg: svgs.check_thin_sm, yOffset: 1 }],
    ["dialog-close", { svg: svgs.close_dialog }],
    ["download", { svg: svgs.data_transfer_download_sm }],
    ["upload", { svg: svgs.data_transfer_upload_sm }],
    ["document", { svg: svgs.document_sm }],
    ["dropdown", { svg: svgs.sort_asc, size: 8 }],
    ["exclamation", { svg: svgs.exclamation }],
    ["expand-expanded", { svg: svgs.circle_up, size: 23, yOffset: -2 }],
    ["expand-collapsed", { svg: svgs.circle_down, size: 23, yOffset: -2 }],
    ["edit-pen", { svg: svgs.pencil_sm }],
    ["input-search", { svg: svgs.magnifying_glass_sm }],
    ["info", { svg: svgs.info_sm }],
    ["link", { svg: svgs.link_intact_sm }],
    ["list-bullet", { svg: svgs.shape_circle_sm }],
    ["lock-locked", { svg: svgs.lock_locked_sm }],
    ["lock-unlocked", { svg: svgs.lock_unlocked_sm }],
    ["logout", { svg: svgs.account_logout_sm }],
    ["menu-user", { svg: svgs.person_genderless_sm, size: 14 }],
    ["next", { svg: svgs.caret_right_sm }],
    ["print", { svg: svgs.print_sm }],
    ["plus", { svg: svgs.plus_sm, size: 8 }],
    ["previous", { svg: svgs.caret_left_sm }],
    ["reset", { svg: svgs.x_thin_sm }],
    ["sensur-complete", { svg: svgs.circle_check_sm }],
    ["skole", { svg: svgs.building_sm }],
    ["sort-indicator-asc", { svg: svgs.sort_asc, size: 8, xOffset: 2 }],
    ["sort-indicator-desc", { svg: svgs.sort_desc, size: 8, xOffset: 4 }],
    ["spreadsheet", { svg: svgs.spreadsheet_sm }],
    ["stopwatch", { svg: svgs.timer_sm }],
    ["tab-arrow", { svg: svgs.tab_arrow }],
    ["tag-remove", { svg: svgs.x_thin_sm }],
    ["trash", { svg: svgs.trash_sm }],
    ["userguide", { svg: svgs.book_sm }],
    ["userprofile", { svg: svgs.person_genderless_sm }],
    ["chevron-top", { svg: svgs.chevron_top_sm, colorizeBy: "stroke" }],
    ["chevron-right", { svg: svgs.chevron_right_sm, colorizeBy: "stroke" }],
    ["chevron-bottom", { svg: svgs.chevron_bottom_sm, colorizeBy: "stroke" }],
    ["chevron-left", { svg: svgs.chevron_left_sm, colorizeBy: "stroke" }],
    ["eye", { svg: svgs.eye_open_sm }],
    ["warning", { svg: svgs.warning_sm }],
    ["reload", { svg: svgs.reload_sm }],
    ["pencil-square-o", { svg: svgs.pencil_square_o, yOffset: 2 }],
    ["home", { svg: svgs.home_sm }],
    ["info-with-circle", { svg: svgs.infoWithCircle }]
]);
//# sourceMappingURL=icons.js.map